import { NavLink, Outlet } from "react-router-dom";
import { Icon } from "../../components/icons";
import { useApp } from "../../store/hooks";
import { Forbidden } from "./shared";

export function AdminLayout() {
  const role = useApp((s) => s.me?.orgs.find((o) => o.org.id === s.orgId)?.role);
  const orgName = useApp((s) => s.me?.orgs.find((o) => o.org.id === s.orgId)?.org.name);
  if (role !== "owner" && role !== "admin") return <Forbidden />;
  return (
    <div className="page admin">
      <header className="page-head">
        <h1 className="admin-title">
          <Icon name="shield" size={22} />
          Admin
          {orgName && <span className="muted admin-org">{orgName}</span>}
        </h1>
      </header>
      <nav className="tabs" aria-label="Admin sections">
        <NavLink to="/admin/overview">Overview</NavLink>
        <NavLink to="/admin/members">Members</NavLink>
        <NavLink to="/admin/identities">Identities</NavLink>
        <NavLink to="/admin/sync">Connections &amp; sync</NavLink>
        <NavLink to="/admin/audit">Audit log</NavLink>
        <NavLink to="/admin/settings">Settings</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
